module.exports = __webpack_public_path__ + "static/media/prototype-illustration.d63b25fa.svg";